import { ArticleHeading2, Button } from '@cian/ui-kit';

import { FC, ReactNode } from 'react';

import { IconOk } from '../UI/Icons/IconOk';

import { OperatorDescription } from './internal/components/OperatorDescription';
import { SpecialistDescription } from './internal/components/SpecialistDescription';
import { ModalContentStageSuccessProps } from './types';

import * as styles from './ModalContentStageSuccess.css';

export const ModalContentStageSuccess: FC<ModalContentStageSuccessProps> = props => {
  const { onNextStage, phoneNumber = null, descriptionType } = props;

  const descriptionView: ReactNode = (() => {
    switch (descriptionType) {
      case 'operator':
        return <OperatorDescription phoneNumber={phoneNumber} />;
      case 'specialist':
        return <SpecialistDescription />;
      // istanbul ignore next
      default:
        return null;
    }
  })();

  return (
    <div className={styles['container']} data-testid="modal-content-stage-success">
      <IconOk />
      <div className={styles['title-container']}>
        <ArticleHeading2 as="h2" color="black_100" fontWeight="bold">
          Ваша заявка отправлена
        </ArticleHeading2>
      </div>
      {descriptionView}
      <div className={styles['button-container']}>
        <Button size="XS" theme="fill_primary" type="button" onClick={onNextStage}>
          Хорошо
        </Button>
      </div>
    </div>
  );
};

ModalContentStageSuccess.displayName = 'ModalContentStageSuccess';
